import localFont from "next/font/local";
import { getSelectableFontsForBrand } from "rylak-common";

const interFont = localFont({
    // src: [
    //     {
    //         path: "../../../../public/fonts/Inter/static/Inter-Light.ttf",
    //         weight: "300",
    //         style: "normal",
    //     },
    //     {
    //         path: "../../../../public/fonts/Inter/static/Inter-Medium.ttf",
    //         weight: "400",
    //         style: "normal",
    //     },
    //     {
    //         path: "../../../../public/fonts/Inter/static/Inter-SemiBold.ttf",
    //         weight: "500",
    //         style: "normal",
    //     },
    //     {
    //         path: "../../../../public/fonts/Inter/static/Inter-Bold.ttf",
    //         weight: "700",
    //         style: "normal",
    //     },
    //     {
    //         path: "../../../../public/fonts/Inter/static/Inter-Black.ttf",
    //         weight: "900",
    //         style: "normal",
    //     },
    // ],
    // src: "../../../../public/fonts/Inter/Inter-VariableFont_slnt,wght.ttf",
    src: "../../../../public/fonts/Inter/Inter.var.woff2",
    // src: "../../../../public/fonts/Inter-4.0/InterVariable.ttf",
    variable: "--brand-font",
});

const robotoFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/Roboto/Roboto-Light.ttf",
            weight: "300",
            style: "normal",
        },
        {
            path: "../../../../public/fonts/Roboto/Roboto-LightItalic.ttf",
            weight: "300",
            style: "italic",
        },
        {
            path: "../../../../public/fonts/Roboto/Roboto-Regular.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../../../public/fonts/Roboto/Roboto-Italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../../../public/fonts/Roboto/Roboto-Bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../../../public/fonts/Roboto/Roboto-BoldItalic.ttf",
            weight: "700",
            style: "italic",
        },
        {
            path: "../../../../public/fonts/Roboto/Roboto-Black.ttf",
            weight: "900",
            style: "normal",
        },
        {
            path: "../../../../public/fonts/Roboto/Roboto-BlackItalic.ttf",
            weight: "900",
            style: "italic",
        },
    ],
    variable: "--brand-font",
});

const circularStdFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Light.ttf",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Book.otf",
            weight: "350",
            style: "normal",
        },
        {
            path: "../../../../public/fonts/brand/stylein/CircularStd/CircularStd-BookItalic.otf",
            weight: "350",
            style: "italic",
        },
        {
            path: "../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Medium.otf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/stylein/CircularStd/CircularStd-Bold.otf",
            weight: "700",
        },
    ],
    variable: "--brand-font",
});

const totemeSansFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/toteme/TOTEME-SANS/OTF/TotemeSans-Light.otf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/toteme/TOTEME-SANS/OTF/TotemeSans-LightItalic.otf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../../../public/fonts/brand/toteme/TOTEME-SANS/OTF/TotemeSans-Regular.otf",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/toteme/TOTEME-SANS/OTF/TotemeSans-Italic.otf",
            weight: "500",
            style: "italic",
        },
        {
            path: "../../../../public/fonts/brand/toteme/TOTEME-SANS/OTF/TotemeSans-Bold.otf",
            weight: "700",
        },
        {
            path: "../../../../public/fonts/brand/toteme/TOTEME-SANS/OTF/TotemeSans-BoldItalic.otf",
            weight: "700",
            style: "italic",
        },
    ],
    variable: "--brand-font",
});

const sailecFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/ospreyqa/Sailec-Regular.otf",
            weight: "400",
        },
    ],
    variable: "--brand-font",
});

const cardinalClassicFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/ospreyqa/CardinalClassicMid-Regular.otf",
            weight: "400",
        },
    ],
    variable: "--brand-font",
});

const grotesqueMTFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/sunspel/GrotesqueMT.otf",
            weight: "400",
        },
    ],
    variable: "--brand-font",
});

const serifFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/gant/Serif.otf",
            weight: "400",
        },
    ],
    variable: "--brand-font",
});

const neueHaasGroteskFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/varley/NHaasGroteskDSPro/NHaasGroteskDSPro-45Lt.woff2",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/varley/NHaasGroteskDSPro/NHaasGroteskDSPro-55Rg.woff2",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/varley/NHaasGroteskDSPro/NHaasGroteskDSPro-65Md.woff2",
            weight: "500",
        },
    ],
    variable: "--brand-font",
});

const plantinMTFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/varley/PlantinMTPro/PlantinMTPro-Light.woff2",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/varley/PlantinMTPro/PlantinMTPro-LightItalic.woff2",
            style: "italic",
            weight: "400",
        },
    ],
    variable: "--brand-font",
});

const abcp3rman3ntFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/mainrose/ABCP3rman3nt_Book.otf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/mainrose/ABCP3rman3nt_Bold.otf",
            weight: "700",
        },
    ],
    variable: "--brand-font",
});

const matterFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-Light.otf",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-LightItalic.otf",
            style: "italic",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-Regular.otf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-RegularItalic.otf",
            style: "italic",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-Medium.otf",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-MediumItalic.otf",
            style: "italic",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-SemiBold.otf",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-SemiBoldItalic.otf",
            style: "italic",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-Bold.otf",
            weight: "700",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-BoldItalic.otf",
            style: "italic",
            weight: "700",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-Heavy.otf",
            weight: "900",
        },
        {
            path: "../../../../public/fonts/brand/morris/matter/Matter-HeavyItalic.otf",
            style: "italic",
            weight: "900",
        },
    ],
    variable: "--brand-font",
});

const albraFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/morris/albra/Albra-Light.otf",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/Albra-Regular.otf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/Albra-Medium.otf",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/Albra-Semi.otf",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/Albra-Bold.otf",
            weight: "700",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/Albra-Black.otf",
            weight: "900",
        },
    ],
    variable: "--brand-font",
});

const bumbumAlbraFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Light.otf",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Light-Italic.otf",
            style: "italic",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Regular.otf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/morris/albra/BumbumType-Albra-Regular-Italic.otf",
            style: "italic",
            weight: "400",
        },
    ],
    variable: "--brand-font",
});

const neueHaasUnicaFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/cdlp/NeueHaasUnicaPro-Regular.otf",
            weight: "400",
        },
    ],
    variable: "--brand-font",
});

const arbeitFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-Light.otf",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-LightItalic.otf",
            style: "italic",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-Book.otf",
            weight: "350",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-BookItalic.otf",
            style: "italic",
            weight: "350",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-Regular.otf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-RegularItalic.otf",
            style: "italic",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-Medium.otf",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-MediumItalic.otf",
            style: "italic",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-SemiBold.otf",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-SemiBoldItalic.otf",
            style: "italic",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-Bold.otf",
            weight: "700",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Arbeit/OTF/Arbeit-BoldItalic.otf",
            style: "italic",
            weight: "700",
        },
    ],
    variable: "--brand-font",
});

const ibmPlexMonoFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-Thin.ttf",
            weight: "100",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-ThinItalic.ttf",
            style: "italic",
            weight: "100",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-ExtraLight.ttf",
            weight: "200",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-ExtraLightItalic.ttf",
            style: "italic",
            weight: "200",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-Light.ttf",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-LightItalic.ttf",
            style: "italic",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-Regular.ttf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-Italic.ttf",
            style: "italic",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-Medium.ttf",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-MediumItalic.ttf",
            style: "italic",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-SemiBold.ttf",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-SemiBoldItalic.ttf",
            style: "italic",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-Bold.ttf",
            weight: "700",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/IBM Plex Mono/IBMPlexMono-BoldItalic.ttf",
            style: "italic",
            weight: "700",
        },
    ],
    variable: "--brand-font",
});

const oswaldFont = localFont({
    src: [
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-ExtraLight.ttf",
            weight: "200",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Light.ttf",
            weight: "300",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Regular.ttf",
            weight: "400",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Medium.ttf",
            weight: "500",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-SemiBold.ttf",
            weight: "600",
        },
        {
            path: "../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Bold.ttf",
            weight: "700",
        },
    ],
    variable: "--brand-font",
});

const CIRCULAR_STD_FONT_NAME = "CircularStd";
const ROBOTO_FONT_NAME = "Roboto";
const INTER_FONT_NAME = "Inter";
const TOTEME_SANS_FONT_NAME = "TotemeSans";
const CARDINAL_CLASSIC_FONT_NAME = "CardinalClassic";
const SAILEC_FONT_NAME = "Sailec";
const GROTESQUE_MT_FONT_NAME = "GrotesqueMT";
const SERIF_FONT_NAME = "Serif";
const NEUE_HAAS_GROTESK_FONT_NAME = "Neue Haas Grotesk";
const PLANTIN_MT_FONT = "PlantinMT";
const ABC_P3RMAN3NT_FONT_NAME = "ABCP3rman3nt";
const MATTER_FONT_NAME = "Matter";
const ALBRA_FONT_NAME = "Albra";
const BUMBUM_ALBRA_FONT_NAME = "BumbumType Albra";
const NEUE_HAAS_UNICA_FONT_NAME = "Neue Haas Unica";
const ARBEIT_FONT_NAME = "Arbeit";
const IBM_PLEX_MONO_FONT_NAME = "IBM Plex Mono";
const OSWALD_FONT_NAME = "Oswald";

export function getLocalFont(fontName) {
    const mapper = {
        [INTER_FONT_NAME]: interFont,
        [ROBOTO_FONT_NAME]: robotoFont,
        "Roboto-Regular": robotoFont, // Deprecated. But some stores still have this one selected
        [CIRCULAR_STD_FONT_NAME]: circularStdFont,
        [TOTEME_SANS_FONT_NAME]: totemeSansFont,
        [CARDINAL_CLASSIC_FONT_NAME]: cardinalClassicFont,
        [SAILEC_FONT_NAME]: sailecFont,
        [SERIF_FONT_NAME]: serifFont,
        [GROTESQUE_MT_FONT_NAME]: grotesqueMTFont,
        [NEUE_HAAS_GROTESK_FONT_NAME]: neueHaasGroteskFont,
        [PLANTIN_MT_FONT]: plantinMTFont,
        [ABC_P3RMAN3NT_FONT_NAME]: abcp3rman3ntFont,
        [MATTER_FONT_NAME]: matterFont,
        [ALBRA_FONT_NAME]: albraFont,
        [BUMBUM_ALBRA_FONT_NAME]: bumbumAlbraFont,
        [NEUE_HAAS_UNICA_FONT_NAME]: neueHaasUnicaFont,
        [ARBEIT_FONT_NAME]: arbeitFont,
        [IBM_PLEX_MONO_FONT_NAME]: ibmPlexMonoFont,
        [OSWALD_FONT_NAME]: oswaldFont,
    };

    return mapper[fontName];
}

export const FONTS = [
    // Brand specific fonts
    {
        id: CIRCULAR_STD_FONT_NAME,
        approvedBrands: ["stylein-v2"],
    },
    {
        id: TOTEME_SANS_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["toteme"],
    },
    {
        id: SAILEC_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev", "osprey", "ospreyqa"],
        approvedBrandsPartialMatch: ["toteme"],
    },
    {
        id: CARDINAL_CLASSIC_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev", "osprey", "ospreyqa"],
        approvedBrandsPartialMatch: ["toteme"],
    },
    {
        id: GROTESQUE_MT_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev", "osprey"],
        approvedBrandsPartialMatch: ["sunspel"],
    },
    {
        id: SERIF_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev", "osprey"],
        approvedBrandsPartialMatch: ["Gant"],
    },
    {
        id: NEUE_HAAS_GROTESK_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["Varley", "varley"],
    },
    {
        id: PLANTIN_MT_FONT,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["Varley", "varley"],
    },
    {
        id: ABC_P3RMAN3NT_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["mainrose", "main-rose"],
    },
    {
        id: MATTER_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["Morris", "morris"],
    },
    {
        id: ALBRA_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["Morris", "morris"],
    },
    {
        id: BUMBUM_ALBRA_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["Morris", "morris"],
    },
    {
        id: NEUE_HAAS_UNICA_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["cdlp"],
    },
    {
        id: ARBEIT_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["ellisbrigham", "ellisbrighamqa", "Ellis Brigham"],
    },
    {
        id: IBM_PLEX_MONO_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["ellisbrigham", "ellisbrighamqa", "Ellis Brigham"],
    },
    {
        id: OSWALD_FONT_NAME,
        approvedBrands: ["erik-test", "turnr-dev"],
        approvedBrandsPartialMatch: ["ellisbrigham", "ellisbrighamqa", "Ellis Brigham"],
    },

    // Turnr installed fonts
    INTER_FONT_NAME,
    ROBOTO_FONT_NAME,
    GROTESQUE_MT_FONT_NAME,
    SERIF_FONT_NAME,
    ABC_P3RMAN3NT_FONT_NAME,
    MATTER_FONT_NAME,
    ALBRA_FONT_NAME,
    BUMBUM_ALBRA_FONT_NAME,
    NEUE_HAAS_UNICA_FONT_NAME,
    ARBEIT_FONT_NAME,
    IBM_PLEX_MONO_FONT_NAME,
    OSWALD_FONT_NAME,

    // safe web fonts
    "Arial",
    "Verdana",
    "Helvetica",
    "Tahoma",
    "Trebuchet MS",
    "Times New Roman",
    "Cursive",
    "Georgia",
    "Garamond",
    "Courier New",
];

export function getFontIds() {
    return FONTS.map((font) => font?.id || font);
}

export function getFontSelectOptions(brandName) {
    return getSelectableFontsForBrand({ fonts: FONTS, brandName }).map((font) => ({
        value: font?.id || font,
        label: font?.id ? `${font?.id} (${font.brand})` : font,
    }));
}
